export const quotes_parties_displayed_columns_locale = {
  type: "Party type",
  name: "Company",
  contactPerson: "Contact person",
  account: "Client no.",
  vatNumber: "VAT no."
};
